import React from 'react';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Div from '../Element/Div/Div';
import { resolveIconProps as resolveProps } from '../../shared/utils/resolveIconProps/resolveIconProps';
import { SupportedIconName } from '../../shared/icons';
import { SupportedColor } from '../Element/Element';
import styles from './BaseInput.module.scss';

export interface ResolveIconProps {
  errorText?: string;
  confirmed?: boolean;
  iconName?: SupportedIconName;
  iconColor?: SupportedColor;
  disabled?: boolean;
  svgFocusable?: boolean;
  onIconClick?: () => void;
  handleKeyPress?: (event: React.KeyboardEvent) => any;
}

const ResolveIcon: React.FunctionComponent<ResolveIconProps> = ({
  errorText,
  confirmed,
  iconName,
  iconColor,
  disabled,
  svgFocusable,
  onIconClick,
  handleKeyPress,
}) => {
  const iconProps = resolveProps({
    errorText,
    confirmed,
    iconName,
    iconColor,
    disabled,
    onIconClick,
    handleKeyPress,
  });

  const classNames = [styles.input__iconWrapper];

  if (!!onIconClick) {
    classNames.push(styles.input__iconWrapper_clickable);
  }

  return iconProps ? (
    <Flex centered className={classNames} borderRadius={{ size: 'rounded' }}>
      <Icon
        color={iconColor}
        size="sm"
        svgFocusable={svgFocusable}
        className={styles.input__iconWrapper__icon}
        {...iconProps}
      />
    </Flex>
  ) : (
    <Div style={{ height: '16px', width: '16px' }} />
  );
};

export default ResolveIcon;
